import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Header } from '../../components/common/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAsyncEffect } from '../../helper/hooks/async-hooks';
import { eventInfo, attachments , joinInfo } from '../../types/common';
import { joinUsers, cancelWaitUsers, loginUser } from '../../types/Reievespf005';
import { getEventDetailInfo } from '../../components/event/getEventDetailInfo';
import { getEventAttachments } from '../../components/event/getEventAttachments';
import { getEventJoinUsers } from '../../components/event/getJoinUsers';
import { getCancelwaitUsers } from '../../components/event/getCancelwaitUsers';
import { getLoginName } from '../../components/event/getLoginName';
import { EventDetail } from '../../components/event/EventDetail';
import { JoinUsersList } from '../../components/event/JoinUsersList';
import { CancelWaitUsersList } from '../../components/event/CancelwaitUsersList';
import { Footer } from '../../components/common/Footer';
import { setCancelWaitJoin } from '../../components/event/setCancelWaitJoin';
import { MailSendedModal } from '../../components/event/MailSendedModal';
import { getJoinStatus } from '../../components/event/getJoinStatus';

/**
 * キャンセル待ち参加登録画面
 */
export function Reievespf005() {

    const navigate = useNavigate();

    //  アカウントIDを保存するcookie
    const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
    //  対応会員番号を保存するcookie（秘書の場合のみ）
    const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
    //  ロータリーCDを保存するcookie
    const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])

    //  イベント詳細情報を保持するstate
    const [eventInfo, setEventInfo] = useState<eventInfo>();

    //  添付ファイル情報を保持するstate
    const [eventAttachmentsInfo, setEventAttachmentsInfo] = useState<attachments[]>();

    //  参加予定の会員情報を保持するstate
    const [joinUsers, setJoinUsers] = useState<joinUsers[]>([]);

    //  キャンセル待ちの会員情報を保持するstate
    const [cancelWaitUsers, setCancelWaitUsers] = useState<cancelWaitUsers[]>([]);

    //  ログイン者の氏名を保持するstate
    const [loginName, setLoginName] = useState<loginUser>();

    //  モダールの表示状態を保持するstate
    const [isModal, setIsModal] = useState<boolean>(false);

    //  キャンセル待ちのモダールの表示状態を保持するstate
    const [isCancelModal, setIsCancelModal] = useState<boolean>(false);

    //  メール送信完了の状態を保持するstate
    const [isSend, setIsSend] = useState<boolean>(false);

    //  API呼び出し時のパラメータに設定するアカウントIDを保持するstate
    const [paramId, setParamId] = useState<string>("");

    // 詳細ボタンの状態を保持するstate
    const [isActive, setIsActive] = useState<boolean>(true);

    //  参加可否を保持するstate
    const [joinInfo, setJoinInfo] = useState<joinInfo>({joinFlag:null,cancel_waiting_flag: null});



    //  クエリパラメータからイベントURLを取得
    const query = new URLSearchParams(useLocation().search)
    const eventUrl = query.get('url') || '';

    //  ログイン者のアカウントID
    const loginId = cookieAccId.idCookie



    //  初回レンダリング時、イベント詳細情報、参加予定会員情報、ログイン者の氏名を取得
    useAsyncEffect(async () => {
        if (eventUrl !== '') {
            //  イベント詳細
            const eventDetail = await getEventDetailInfo({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            setEventInfo(eventDetail);

            //  添付ファイル
            const eventAttachments = await getEventAttachments({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            setEventAttachmentsInfo(eventAttachments);


            //  イベント詳細情報が取得できない場合、マイページに遷移
            if (Object.keys(eventDetail).length === 0) {
                navigate('/mypage')
                return;
            }

            //  参加予定の会員
            setJoinUsers(await getEventJoinUsers({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }));

            //  キャンセル待ちの会員
            setCancelWaitUsers(await getCancelwaitUsers({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }));

            let id;
            //  対応会員番号を取得できた場合、パラメータに設定
            if (cookieSecAccId.secIdCookie != null) {
                id = cookieSecAccId.secIdCookie
                setParamId(id);
            } else {
                id = cookieAccId.idCookie
                setParamId(id);
            }
            //  ログイン者の氏名（秘書の場合は対応会員の氏名）
            setLoginName(await getLoginName({
                id: id,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }))

            //  参加可否
            setJoinInfo(await getJoinStatus({
                accountId: id,
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }))
        }
    }, [])

    useEffect(() => {
        //  現在日時
        let currentDateTime = new Date();

        const strLimitTime = eventInfo?.limit_time;
        var strLimitDate = new Date(eventInfo?.limit_date + '').toLocaleDateString();
        var limitDate = new Date(strLimitDate);

        //　対象のユーザがキャンセル待ちでないのであれば当該イベントの詳細ページに遷移
        if(joinInfo.cancel_waiting_flag === false){
            navigate('/detail?url=' + eventUrl)
            return;
        }

        if (limitDate && strLimitTime) {
            //  hh:mm:ss
            const splitToTime = strLimitTime?.split(':')

            //  年月日をそれぞれ取得
            var toHour = splitToTime[0]
            var toMinute = splitToTime[1]
            var toSecond = splitToTime[2]

            //  申込期限日に申込期限時刻を加算
            limitDate.setHours(limitDate.getHours() + Number(toHour))
            limitDate.setMinutes(limitDate.getMinutes() + Number(toMinute))
            limitDate.setSeconds(limitDate.getSeconds() + Number(toSecond))

            //  現在日時と比較し、申込期限を過ぎている場合
            if (limitDate < currentDateTime) {
                navigate(`/detail?url=` + eventUrl)
            }
        }
    })


    //  モーダルの表示切替
    const changeModal = (status: boolean) => {
        setIsModal(status)
    }

    //  キャンセル待ちのモーダルの表示切替
    const changeCancelModal = (status: boolean) => {
        setIsCancelModal(status)
    }

    //  参加ボタン押下時
    const registerClick = async () => {
        let res = null;
        /**
         * 申込期限切れの場合、キャンセル待ち人数の表示やモーダル内容変更の必要あり
         */

        if (eventUrl) {
            res = await setCancelWaitJoin({
                accountId: loginId,
                paramId: paramId,
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
        }
        //  メール送信まで完了したらモーダル表示
        if (res !== null && res.result === true) {
            setIsSend(true)
        } else {
            navigate(0)
            return;
        }
    }

    return (
        <div className={`l-wrapper sp-view ${isModal === true ? "is-modal" : ""} ${isSend === true ? "is-modal" : ""} ${isCancelModal === true ? "is-modal" : ""}`}>
            <main className="l-contents">
                <Header />

                <div className="l-default-content">
                    <div className="l-inner">
                        <div className="l-title">
                            <h2 className="title-txt">キャンセル待ち参加登録</h2>
                        </div>

                        {/* <!-- 空き状況メッセージ --> */}
                        {(eventInfo) && (eventInfo.cancel_member_count > 0) ?
                            <div className="message-area">
                                <div className="message-box">
                                    <p className="ttl">現在、残り{eventInfo.cancel_member_count}名参加可能</p>
                                    <p className="txt">先着順のため、参加できない可能性がございます。</p>
                                </div>
                            </div>
                            :
                            <div className="message-area">
                                <div className="message-box">
                                    <p className="ttl">定員を満たしたため、受付は終了しました</p>
                                </div>
                            </div>
                        }

                        {/* <!-- /.message-area --> */}

                        <div className="l-record-wrap">
                            <EventDetail
                                detail={eventInfo ?? {
                                    subject: "",
                                    attachment_url: "",
                                    mime_type: "",
                                    icon_class: "",
                                    event_type_name: "",
                                    date: "",
                                    from_time: "",
                                    to_time: "",
                                    limit_member: 0,
                                    join_num : 0,
                                    location: "",
                                    contents : "",
                                    place:"",
                                    member_fee: 0,
                                    limit_date: "",
                                    limit_time: "",
                                    reception_time: "",
                                    phone_number: "",
                                    bank_branch : "",
                                    transfer_method : "",
                                    bank_account_address : "",
                                    bank_account_name : "",
                                    limit_bank_date : "",
                                    limit_bank_time : "",
                                    limit_date_join_num: 0,
                                    cancel_member_count: 0,
                                }}
                                attachments={eventAttachmentsInfo ?? []}
                                isActive={isActive}
                                setIsActive={setIsActive}
                            />

                            <div className="link-box">
                                <button
                                    className="link-icon"
                                    onClick={() => changeModal(true)}
                                >
                                    参加予定の会員

                                    <i className="ic-member"><img src="img/ic_member.svg" alt="" /></i></button>
                            </div>

                            <div className="link-box">
                                <button
                                    className="link-icon"
                                    onClick={() => changeCancelModal(true)}
                                >
                                    キャンセル待ちの会員

                                    <i className="ic-member"><img src="img/ic_member_W.svg" alt="" /></i></button>
                            </div>
                        </div>
                        {/**空き枠がある場合のみformを表示 */}
                        {(eventInfo) && (eventInfo.cancel_member_count > 0) &&
                            <form>
                                <div className="event-wrap">
                                    <div className="form-are">
                                        <div className="form-set">
                                            <dl>
                                                <dt className="fsz-m1 fw-b">{loginName?.name}様</dt>
                                            </dl>
                                        </div>
                                    </div>
                                    <div className="btn-area flex-column col1">
                                        <div className="record-notice">
                                            <span className="stxt">キャンセル待ち参加登録を実行します。<br />先着順のため、参加できない可能性がございます。</span>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn-main btnsz-l"
                                            onClick={() => registerClick()}
                                        >
                                            参加
                                        </button>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                </div>

                {/**参加予定の会員　モーダル */}
                {isModal &&
                    <JoinUsersList
                        users={joinUsers}
                        onClick={() => changeModal(false)}
                    />
                }

                {/**キャンセル待ちの会員　モーダル */}
                {isCancelModal &&
                    <CancelWaitUsersList
                        users={cancelWaitUsers}
                        onClick={() => changeCancelModal(false)}
                    />
                }

                {/**メール送信完了モーダル */}
                {isSend &&
                    <MailSendedModal
                        more_flag={false}
                    />
                }
            </main>
            <Footer />
        </div>

    );
}